import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AppDatePipe } from 'src/app/shared/pipes/app-date.pipe';
import { TranslateModule } from '@ngx-translate/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { ReleaseNotesListComponent } from './components/release-notes-list/release-notes-list.component';
import { ReleaseNotesDialogComponent } from './components/release-notes-dialog/release-notes-dialog.component';

@NgModule({
  declarations: [ReleaseNotesListComponent, ReleaseNotesDialogComponent],
  imports: [CommonModule, TranslateModule.forChild(), MatDialogModule, MatButtonModule, AppDatePipe],
  exports: [ReleaseNotesListComponent],
})
export class ReleaseNotesModule {}
